<template>
	<div>
		<v-row class="mt-5" >
			<v-col cols="6">
				<v-toolbar color="primary" dark>
					<v-toolbar-title>Configuration for {{settings.name}}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="$emit('close')">
						<v-icon>far fa-times</v-icon>
					</v-btn>
				</v-toolbar>
				<v-card v-if="isAdmin">
					<v-card-text>
						<v-row  >
							<v-col class="pr-3" cols="6" >
								<img v-if="settings.customLogo" :src="settings.customLogo" height="100" class="pb-3" />
								<file-upload ref="fu1" :viewable="false" :url="settings.customLogo" label="Custom Logo Image" name="custom-logo" type="image" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6" />
							<v-col class="pr-3" cols="6" >
								<file-upload ref="fu2" :viewable="true" :url="settings.holterReportConfigUrl" label="Holter Report Config" name="holter-report-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6">
								<file-upload ref="fu3" :viewable="true" :url="settings.holterAnalysisConfigUrl" label="Holter Analysis Config" name="holter-analysis-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col class="pr-3" cols="6" >
								<file-upload ref="fu4" :viewable="true" :url="settings.eventReportConfigUrl" label="Event Report Config" name="event-report-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6">
								<file-upload ref="fu5" :viewable="true" :url="settings.eventAnalysisConfigUrl" label="Event Analysis Config" name="event-analysis-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col class="pr-3" cols="6" >
								<file-upload ref="fu6" :viewable="true" :url="settings.snapshotReportConfigUrl" label="Snapshot Report Config" name="snapshot-report-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="6">
								<file-upload ref="fu7" :viewable="true" :url="settings.snapshotAnalysisConfigUrl" label="Snapshot Analysis Config" name="snapshot-analysis-config" type="file" @clear="fileClear" @change="fileChange" />
							</v-col>
							<v-col cols="12">
								<v-checkbox v-model="app.useBetaFeatures" label="Use Beta Features" />
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn @click="update" color="primary" :disabled="updating" :loading="updating">Save Configuration</v-btn>
					</v-card-actions>
				</v-card>
				<v-card v-else>
					<v-card-text>
						<v-row  >
							<v-col class="pb-3" cols="6" >
								<img v-if="settings.customLogo" :src="settings.customLogo" height="100" />
								<div v-else class="image-placeholder">No Logo</div>
							</v-col>
							<v-col cols="6" />
							<v-col class="pr-3" cols="6" >
								<file-view :url="settings.holterReportConfigUrl" label="Holter Report Config" />
							</v-col>
							<v-col cols="6">
								<file-view :url="settings.holterAnalysisConfigUrl" label="Holter Analysis Config" />
							</v-col>
							<v-col class="pr-3" cols="6" >
								<file-view :url="settings.eventReportConfigUrl" label="Event Report Config" />
							</v-col>
							<v-col cols="6">
								<file-view :url="settings.eventAnalysisConfigUrl" label="Event Analysis Config" />
							</v-col>
							<v-col class="pr-3" cols="6" >
								<file-view :url="settings.snapshotReportConfigUrl" label="Snapshot Report Config" />
							</v-col>
							<v-col cols="6">
								<file-view :url="settings.snapshotAnalysisConfigUrl" label="Snapshot Analysis Config" />
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</div>

</template>

<script>
import analysisApi from "../../analysisApi";
import FileUpload from "../file-upload.vue";
import FileView from "../file-view.vue";

export default {
	props: {
		settings: Object,
	},
	components: {
		FileUpload,
		FileView,
	},
	data() {
		return {
			app: {
				id: this.settings.id,
				applicationFiles: [],
				useBetaFeatures: this.settings.useBetaFeatures,
			},
			updating: false,
			updated: false,
		};
	},
	methods: {
		update() {
			this.updating = true;
			analysisApi.updateApplicationConfig(this.app)
				.then(() => {
					this.$emit("update");
					this.$emit("close");
					// this.updated = true;
					this.showToast("success", "Application Updated");
				})
				.catch((e) => {
					this.showError(e);
				})
				.finally(() => {
					this.updating = false;
				});
		},
		fileClear(name) {
			this.app.applicationFiles = this.app.applicationFiles.filter(f => !f.fileName.startsWith(name));
		},
		fileChange(data) {
			this.app.applicationFiles.push(data);
		},
	},
};
</script>
